import React, { Fragment, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Card, Col, Row } from "react-bootstrap";
import { decryptData } from "../../../functions/cryptoUtils";
import LazyImage from "../../../functions/LazyImage";
import { useNavigate } from "react-router-dom";

const Campana = () => {
  const encryptedUser = useSelector((store: any) => store.authreducer.user);
  const user = decryptData(encryptedUser);
  const navigate = useNavigate();
  const clientesPermitidos = [2268, 1176, 186, 1144, 1432];
  const clienteTienePermiso = clientesPermitidos.includes(user?.clienteCodigo);

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div>
          <Row className="wd-70p m-auto">
            <Col>
              {/* <Col> */}
              <Card
                className="text-center border-0 shadow-lg card-hover"
                style={{
                  borderRadius: "15px",
                  overflow: "hidden",
                  border: "none",
                }}
              >
                <Card.Header
                  as="h4"
                  className="py-3 text-white"
                  style={{
                    backgroundColor: "#D0121D",
                    borderBottom: "none",
                  }}
                >
                  <i
                    className="bi bi-gift mg-r-5"
                    style={{
                      fontSize: "20px",
                    }}
                  ></i>
                  Campañas
                </Card.Header>
                {/* <div className="left-content wd-100p mg-b-5">
                  <LazyImage
                    className="wd-100p ht-100"
                    src={`https://ferretera-img-web-prod.s3.sa-east-1.amazonaws.com/public/img/Imagenes/Marcas/PortadaMarcas/13_xxl.webp`}
                    alt="Logo Marca"
                    onError={(e: any) => {
                      // e.target.src = `https://ferretera-img-web-prod.s3.sa-east-1.amazonaws.com/public/img/Imagenes/Marcas/PortadaMarcas/${marcaId}.webp`
                    }}
                  />
                </div> */}
                <Card.Body
                  className="py-4 px-5"
                  style={{ backgroundColor: "#fff" }}
                >
                  <div className="mb-4">
                    <Card.Title
                      className="h4 mb-3"
                      style={{ color: "#D0121D" }}
                    >
                      Pensando en la ferreteria del futuro
                    </Card.Title>
                    <Card.Text className="text-dark mb-4">
                      En Ferretera Central sabemos lo que necesita el ferretero.
                      Por eso, estamos desarrollando una nueva forma de
                      potenciar tu negocio: acercándote directamente a las
                      marcas que vos elegís. Queremos que tengas acceso a
                      beneficios exclusivos y ofertas especiales de las marcas
                      que más usás en tu día a día.
                      <br />
                      <br />
                      <strong>
                        Si queres participar de alguna de estas campañas
                        consulta todas las condiciones a tu representante de
                        venta.
                      </strong>
                    </Card.Text>
                  </div>
                </Card.Body>
                <Card.Footer
                  className="py-3"
                  style={{
                    backgroundColor: "#D0121D", // tono pastel suave
                    borderTop: "1px solid  #D0121D",
                  }}
                >
                  {/* {clienteTienePermiso ? (
                    <Button
                      variant="outline-dark"
                      onClick={() => navigate("/principal/campanadetalle")}
                      className="px-4 py-2 rounded-pill"
                      style={{
                        fontWeight: "600",
                        borderWidth: "2px",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <i className="fas fa-home me-2"></i>
                      Seguimiento de campaña
                    </Button>
                  ) : (
                    <small className="text-dark">
                      <i className="fas fa-clock me-1"></i>
                      Para poder acceder a esta seccion debes estar habilitado
                    </small>
                  )} */}
                </Card.Footer>
              </Card>
              {/* </Col> */}

              <Card
                className="text-center border-0 shadow-lg card-hover"
                style={{
                  borderRadius: "15px",
                  overflow: "hidden",
                  border: "none",
                }}
              >
                <Card.Header
                  as="h4"
                  className="py-3 text-white"
                  style={{
                    backgroundColor: "#FFB300",
                    borderBottom: "none",
                  }}
                >
                   <i
                    className="bi bi-gift mg-r-5"
                    style={{
                      fontSize: "20px",
                    }}
                  ></i>
                  INGCO select
                </Card.Header>
                <div className="left-content wd-100p mg-b-5">
                  <LazyImage
                    className="wd-100p ht-100"
                    src={`https://ferretera-img-web-prod.s3.sa-east-1.amazonaws.com/public/img/Imagenes/Marcas/PortadaMarcas/13_xxl.webp`}
                    alt="Logo Marca"
                    onError={(e: any) => {
                      // e.target.src = `https://ferretera-img-web-prod.s3.sa-east-1.amazonaws.com/public/img/Imagenes/Marcas/PortadaMarcas/${marcaId}.webp`
                    }}
                  />
                </div>
                <Card.Body
                  className="py-4 px-5"
                  style={{ backgroundColor: "#f8f9fa" }}
                >
                  <div className="mb-4">
                    <div className="icon-container">
                      <i
                        className="si si-user-follow"
                        style={{
                          fontSize: "x-large",
                          color: "#FFB300",
                        }}
                      ></i>
                    </div>
                    {/* <Card.Title
                      className="h4 mb-3"
                      style={{ color: "#FFB300" }}
                    > */}
                    <h4 style={{ color: "#FFB300" }}>
                      Aprovecha beneficios exclusivos
                    </h4>
                    {/* </Card.Title> */}
                    <Card.Text className="text-dark mb-4">
                      <strong style={{ color: "#000" }}>
                        Hacete parte del INGCO Select para impulsar la marca en
                        tu negocio
                      </strong>
                      <br />
                      <br />
                      Conoce todos los beneficios que te trae sumarte a la
                      campaña "INGCO SELECT".
                      <br />
                      Hace crecer tu negocio, hace crecer la marca.
                      <br />
                      <br />
                      Si queres pertenecer a este grupo, consulta todas las
                      condiciones a tu representante de venta.
                    </Card.Text>
                  </div>
                </Card.Body>
                <Card.Footer
                  className="py-3"
                  style={{
                    backgroundColor: "#FFF2CC", // tono pastel suave
                    borderTop: "1px solid #FFB300",
                  }}
                >
                  {/* {clienteTienePermiso ? (
                    <Button
                      variant="outline-dark"
                      onClick={() => navigate("/principal/campanadetalle")}
                      className="px-4 py-2 rounded-pill"
                      style={{
                        fontWeight: "600",
                        borderWidth: "2px",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <i className="fas fa-home me-2"></i>
                      Seguimiento de campaña
                    </Button>
                  ) : (
                    <small className="text-dark">
                      <i className="fas fa-clock me-1"></i>
                      Para poder acceder a esta seccion debes estar habilitado
                    </small>
                  )} */}
                </Card.Footer>
              </Card>
            </Col>
            {/* <Col>
              <Card
                className="text-center border-0 shadow-lg card-hover"
                style={{
                  borderRadius: "15px",
                  overflow: "hidden",
                  border: "none",
                }}
              >
                <Card.Header
                  as="h4"
                  className="py-3 text-white"
                  style={{
                    backgroundColor: "#da2c38",
                    borderBottom: "none",
                  }}
                >
                  <i className="fas fa-rocket me-2"></i>
                  Biassoni Point
                  // id=244 
                </Card.Header>
                <div className="left-content wd-100p mg-b-5">
                  <LazyImage
                    className="wd-100p ht-100"
                    src={`https://ferretera-img-web-prod.s3.sa-east-1.amazonaws.com/public/img/Imagenes/Marcas/PortadaMarcas/244_xxl.webp`}
                    alt="Logo Marca"
                    onError={(e: any) => {
                      // e.target.src = `https://ferretera-img-web-prod.s3.sa-east-1.amazonaws.com/public/img/Imagenes/Marcas/PortadaMarcas/${marcaId}.webp`
                    }}
                  />
                </div>
                <Card.Body
                  className="py-4 px-5"
                  style={{ backgroundColor: "#f8f9fa" }}
                >
                  <div className="mb-4">
                    <div className="icon-container">
                      <i
                        className="si si-user-follow"
                        style={{
                          fontSize: "x-large",
                          color: "#da2c38",
                        }}
                      ></i>
                    </div>
                    <Card.Title
                      className="h4 mb-3"
                      style={{ color: "#da2c38" }}
                    >
                      Aprovecha beneficios exclusivos
                    </Card.Title>
                    <Card.Text className="text-dark mb-4">
                      <strong style={{ color: "#000" }}>
                        Hacete parte del INGCO Select para impulsar la marca en
                        tu negocio
                      </strong>
                      <br />
                      <br />
                      Conoce todos los beneficios que te trae sumarte a la
                      campaña "INGCO Select", hace que te negocio crezca, hace
                      que la marca crezca.
                      <br />
                      <br />
                      Si queres pertenecer a este grupo, consulta todas las
                      condiciones a tu representante de venta.
                    </Card.Text>
                  </div>
                </Card.Body>
                <Card.Footer
                  className="py-3"
                  style={{
                    backgroundColor: "#da2c38", // tono pastel suave
                    borderTop: "1px solid #da2c38",
                  }}
                >
                  <small className="text-white">
                    <i className="fas fa-clock me-1"></i>
                    Para poder acceder a esta seccion debes estar habilitado
                  </small>
                </Card.Footer>
              </Card>
            </Col> */}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Campana;
